import { createStyles, makeStyles } from "@material-ui/core";
import * as React from "react";

import { RelodeTheme } from "../styles";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                position: "fixed",
                top: theme.relode.sizes.mobileAppBarHeight,
                backgroundColor: theme.palette.common.white,
                width: "100%",
                zIndex: 1000,
                height: (props: MobileHeaderProps) =>
                    props.showTabs && props.showStatusLabel
                        ? theme.relode.sizes.mobileHeaderHeight +
                          theme.relode.sizes.mobileTabHeight +
                          theme.relode.sizes.mobileHeaderStatusLabelHeight
                        : props.showTabs
                        ? theme.relode.sizes.mobileHeaderHeight +
                          theme.relode.sizes.mobileTabHeight
                        : theme.relode.sizes.mobileHeaderHeight,
                display: "grid",
                gridTemplateColumns: "1fr",
                gridTemplateRows: "0px 1fr auto",
                gridAutoRows: "1fr",
                alignItems: "center",
                justifyContent: "center",
                boxShadow:
                    "0px 2px 4px -1px rgba(0, 0, 0, 0.3), 0px 4px 4px 0px rgba(0, 0, 0, 0.14)",
            },
        }),
    { name: "MobileHeader" }
);

interface MobileHeaderProps {
    showTabs: boolean;
    showStatusLabel: boolean;
    children?: React.ReactNode;
}

export const MobileHeader = (props: MobileHeaderProps) => {
    const classes = useStyles(props);
    
    if (!props.children) return null;
    
    return (
        <div id="mobile-header" className={classes.root}>
            {props.children}
        </div>
    );
};
